<template>
	<div class="main">
		<div v-for="(item,index) in honorList" :key="index" class="honor">
			<el-image fit="contain" class="honorImg" :src="item" :preview-src-list="honorList"></el-image>
		</div>
	</div>
</template>

<script>
export default {
	name: "Honor",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			honorList: []
		}
	},
	mounted() {
		this.$api.get('about/getHonor').then(res => {
			let l = [];
			for(let i=0; i<res.length; i++){
				l[i] = this.baseImgUrl + res[i];
			}
			this.honorList = l;
		});
	}
}
</script>

<style scoped>
	@media (max-width: 500px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 2px 0 0 0; }
		.honor{ width: 100%; height: 320px; margin-bottom: 5px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 500px) and (max-width: 726px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 48%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 726px) and (max-width: 999px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 32%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 999px) and (max-width: 1251px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 24%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 1252px) and (max-width: 1845px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 20%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 1846px) and (max-width: 2200px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 20%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
	@media (min-width: 2201px){
		.main{ display: flex; flex-wrap: wrap; justify-content: flex-start; width: 100%; padding: 30px 0 0 0; }
		.honor{ width: 20%; height: 320px; margin-bottom: 30px; animation: bounceIn; animation-duration: 1s; }
		.honorImg{ width: 100%; height: 100%; }
	}
</style>